<template>
    <div>
        <v-dialog v-if="loading.data"
        
            :width="loading.data ? 350 : 900"
            persistent
            hide-overlay
            v-model="display"
            >
                <div class="text-center d-flex flex-column justify-center align-center pa-2" style="height: 100%" >
                    <v-progress-linear
                    height="4"
                        indeterminate>
                    </v-progress-linear>
                    <div class="text-body-1 pa-2">Please Wait ...</div>
                </div>
        </v-dialog>
        <v-dialog 
            v-else
            :width="loading.data ? 350 : 900"
            persistent
            v-model="display" 
            >
            <v-card  flat :height="loading.data ? 80 : null">
                  <v-toolbar flat color="primary" dark v-if="!loading.data" dense>
                    <v-toolbar-title>Debit Note</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <p-icon-btn icon="mdi-form-select" tooltip="Simulate Entry" @click="simulate" :loading="loading.simulate"></p-icon-btn>
                    <p-icon-btn icon="mdi-printer" tooltip="Print" disabled></p-icon-btn>
                </v-toolbar> 
                <v-card-text  class="mt-4">
                    <v-alert text type="info" v-if="loading.simulate" dense v-html="aicaSimulatingAlert"></v-alert>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-subheader>Generate Information</v-subheader>
                            <v-simple-table dense>
                                <tbody>
                                    <tr>
                                        <th>Code</th>
                                        <td>{{ debitNoteData.code }}</td>
                                    </tr>
                                    <tr>
                                        <th>Date</th>
                                        <td>
                                            {{ formatTimestamp(debitNoteData.created_at) }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Document Date</th>
                                        <td>{{ debitNoteData.date }}</td>
                                    </tr>
                                    <tr>
                                        <th>State</th>
                                        <td>
                                            <p-status :state="debitNoteData.state"></p-status>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-subheader>Customer Information</v-subheader>
                            <document-customer-preview :id="debitNoteData.customer_id" v-if="debitNoteData.customer_id"></document-customer-preview>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-simple-table dense class="text-body-1">
                                <thead>
                                    <tr>
                                        <th>Description</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ debitNoteData.notes }}</td>
                                        <td>{{ formatNumber(debitNoteData.amount, 2) }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12">
                            <v-simple-table dense>
                                <tbody>
                                    <tr>
                                        <th>Created By</th>
                                        <td>{{debitNoteData.created_by}}</td>
                                        <th>Created At</th>
                                        <td>{{formatTimestamp(debitNoteData.created_at)}}</td>
                                    </tr>         
                                    <tr>
                                        <th>Updated By</th>
                                        <td>{{debitNoteData.updated_by}}</td>
                                        <th>Updated At</th>
                                        <td>{{formatTimestamp(debitNoteData.updated_at)}}</td>
                                    </tr>   
                                    <tr v-if="isPosted">
                                        <th>Posted By</th>
                                        <td>{{debitNoteData.posted_by}}</td>
                                        <th>Posted At</th>
                                        <td>{{formatTimestamp(debitNoteData.posted_at)}}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="display = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- TODO: can post to be changed with the real permissions -->
        <simulate-entries
            v-if="simulateEntryShown" 
            v-model="simulateEntryShown" 
            :entry="entry" 
            :is-posted="isPosted" 
            :can-post="true"
            @post="post"
            :is-posting="loading.post">
        </simulate-entries>
        <AlertDialog 
            ref="alertDialog"/>
    </div>
</template>

<script>
import moment from "moment";
import { formatNumber } from 'accounting';

import { aicaSimulatingAlert, aicaPostedAlert } from "../../assets/text/alerts";
import { getDpk } from "../../services/sales";
import { getDebitNote, postDebitNote, simulateDebitNote } from "../../services/sales/debitNote";

import PIconBtn from "../common/PIconBtn";
import DocumentCustomerPreview from "../Sales/DocumentCustomerPreview";
import SimulateEntries from "../accounting/SimulateEntries.vue";
import PStatus from '../common/PStatus';
import AlertDialog from '@/components/common/AlertDialog';

// import LoadingDialog

export default {
    name: "DebitNoteDisplay",
    components: { PIconBtn, DocumentCustomerPreview, SimulateEntries, PStatus, AlertDialog },
    props: {
        value: Boolean,
        debitNote: { type: Object, required: true },
    },
    data() {
        return {
            debitNoteData: {},
            loading: {
                data: false,
                simulate: false,
                post: false
            },
            entry: {},
            simulateEntryShown: false,
            aicaSimulatingAlert,
            aicaPostedAlert,
            dpk: null
        };
    },
    computed: {
        display: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        isPosted() {
            return this.debitNoteData.is_posted;
        }
    },
    methods: {
        formatNumber,
        formatTimestamp(timestamp) {
            return moment(timestamp).format("YYYY-MM-DD");
        },
        fetchDebitNote() {
            this.loading.data = true;
            getDebitNote(this.debitNote.id)
                .then((response) => {
                    this.debitNoteData = response.data;
                })
                .finally(() => (this.loading.data = false));
        },
        simulate() {
            this.loading.simulate = true;
            simulateDebitNote({ debitNoteId: this.debitNoteData.id })
                .then((response) => {
                    this.entry = response.data;
                    this.simulateEntryShown = true;
                }).catch((error) => {
                    this.loading.simulate = false;
                    let message = error.response ? error.response.data.message : error;
                    let errors = error.response ? error.response.data.errors : [];
                    message += '\n';
                    message += errors.join();
                    this.$refs.alertDialog.open({type: "error", message});
                }).finally(() => (this.loading.simulate = false));
        },
        post() {
            this.loading.post = true;
            postDebitNote({ debitNoteId: this.debitNoteData.id, dpk: this.dpk })
                .then(response => {
                    this.debitNoteData = response.data.record;
                    this.simulateEntryShown = false;
                    this.$emit("updated");
                }).catch((error) => {
                    this.loading.simulate = false;
                    let message = error.response ? error.response.data.message : error;
                    let errors = error.response ? error.response.data.errors : [];
                    message += '\n';
                    message += errors.join();
                    this.$refs.alertDialog.open({type: "error", message});
                }).finally(() => {
                    this.loading.post = false;
                });
        },
        fetchDpk() {
            getDpk().then((response) => (this.dpk = response.data.key));
        },
    },
    created() {
        this.fetchDebitNote();
        this.fetchDpk();
    },
};
</script>
